module.exports = __webpack_public_path__ + "img/thumb_23.017ee9e4.jpg";